import { create } from 'zustand'
import type { Tone, Audience, MessageType, RedactorStatus } from '../types'

interface RedactorState {
  // Input
  inputText: string
  tone: Tone
  audience: Audience
  messageType: MessageType
  skillId: string | null

  // Output
  outputText: string
  status: RedactorStatus
  errorMessage: string | null
  inputTokens: number | null
  outputTokens: number | null

  // Actions
  setInputText: (text: string) => void
  setTone: (tone: Tone) => void
  setAudience: (audience: Audience) => void
  setMessageType: (messageType: MessageType) => void
  setSkillId: (skillId: string | null) => void
  setOutputText: (text: string) => void
  appendOutputText: (chunk: string) => void
  setStatus: (status: RedactorStatus) => void
  setError: (message: string) => void
  setTokenUsage: (input: number, output: number) => void
  reset: () => void
}

const DEFAULT_STATE = {
  inputText: '',
  tone: 'diplomatic' as Tone,
  audience: 'team' as Audience,
  messageType: 'slack' as MessageType,
  skillId: null,
  outputText: '',
  status: 'idle' as RedactorStatus,
  errorMessage: null,
  inputTokens: null,
  outputTokens: null,
}

export const useRedactorStore = create<RedactorState>((set) => ({
  ...DEFAULT_STATE,

  setInputText: (text) => set({ inputText: text }),
  setTone: (tone) => set({ tone }),
  setAudience: (audience) => set({ audience }),
  setMessageType: (messageType) => set({ messageType }),
  setSkillId: (skillId) => set({ skillId }),
  setOutputText: (text) => set({ outputText: text }),
  appendOutputText: (chunk) =>
    set((state) => ({ outputText: state.outputText + chunk })),
  setStatus: (status) => set({ status }),
  setError: (message) => set({ status: 'error', errorMessage: message }),
  setTokenUsage: (input, output) =>
    set({ inputTokens: input, outputTokens: output }),
  reset: () => set(DEFAULT_STATE),
}))
